import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { initGA, removeGA } from '../utils/analytics';
import './CookieConsent.css';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    
    if (consent === null) {
      // No choice made yet, show banner after a short delay
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (consent === 'accepted') {
      // User previously accepted, initialize GA
      initGA();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    initGA();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
    removeGA();
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <h3 className="cookie-consent-title">{t('cookies.title')}</h3>
          <p className="cookie-consent-text">{t('cookies.message')}</p>
          <p className="cookie-consent-details">{t('cookies.details')}</p>
        </div>
        <div className="cookie-consent-actions">
          <button 
            className="cookie-consent-btn cookie-consent-reject"
            onClick={handleReject}
          >
            {t('cookies.reject')}
          </button>
          <button 
            className="cookie-consent-btn cookie-consent-accept"
            onClick={handleAccept}
          >
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
